import { Input } from "antd";
import Title from "antd/es/typography/Title";
import { FormikContextType } from "formik";
import React, { FC } from "react";
import { DynamicOutputMaterialData } from "shared/api";
import { AddProductionRequest } from "../../ProcessStepProduction";

interface UpdateOutputMaterialQuantityProps {
  materials: DynamicOutputMaterialData[];
  currentPage: number;
  unitName?: string;
  index: number;
  setFieldValue: FormikContextType<AddProductionRequest>["setFieldValue"];
}

const UpdateOutputMaterialQuantity: FC<UpdateOutputMaterialQuantityProps> = ({
  materials,
  currentPage,
  setFieldValue,
  unitName,
  index,
}) => {
  const value = materials?.[currentPage]?.quantity;
  const fieldName = `output_materials.${index}.dynamicData.${currentPage}.quantity`;

  return (
    <div>
      <Title level={5}>{unitName}</Title>
      <Input
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFieldValue(fieldName, Number(e?.target?.value))
        }
        type="number"
        min={1}
      />
    </div>
  );
};

export { UpdateOutputMaterialQuantity };
